<template>
  <transition name="fade">
    <div
      v-if="autoRefresh || refreshPending"
      class="refresh-prompt"
      :class="{ 'refresh-prompt--auto': autoRefresh }"
      @click="$emit('refresh')"
    >
      <div v-if="!autoRefresh" class="refresh-prompt__msg">
        {{ title }}
      </div>
      <Checkbox v-model="autoRefresh" :title="$t('message.PB_AUTO_REFRESH')" @input="autoRefreshInput" />
    </div>
  </transition>
</template>

<script>
import Checkbox from '@/components/checkbox.vue';
import { itemExpand } from '@/utils/expandable';

export default {

  name: 'RefreshPrompt',

  components: {
    Checkbox,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      autoRefresh: false,
      refreshPending: false,
    };
  },

  methods: {
    /** Switch auto refresh in refresh prompt */
    autoRefreshInput() {
      itemExpand({ expanded: this.autoRefresh }, this.refreshMessageId);
      if (this.autoRefresh && this.refreshPending) {
        this.$emit('refresh');
      }
    },
    setRefreshPending(rPending) {
      if (rPending && this.autoRefresh) {
        this.$emit('refresh');
      }
      this.refreshPending = rPending;
    },
  },
};
</script>

<style lang="scss">
.refresh-prompt {
  padding: 7px 15px;
  border-radius: 20px;
  background: #6e96c4;
  color: #ffffff;
  cursor: pointer;
  position: absolute;
  top: 10px;
  left: 30%;
  width: calc(40% - 30px);
  white-space: pre-line;
  font-weight: 600;
  box-shadow: 0px 0px 10px #6e96c4;
  z-index: 10016;
  transition: width .2s;

  &__msg {
    overflow: hidden;
  }

  &--auto {
    width: auto;
    left: calc(50% - 10em);
    transform: translateX(-50%);
  }
}
</style>
